export default __webpack_public_path__ + "static/media/higher_icon_chat_blue.540c6d83.svg";